class ProductForm extends HTMLElement {
    constructor() {
      super();   
  
      this.form = this.querySelector('form');
      if(this.form) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartItems = document.querySelector('cart-items');
      this.miniCart = document.querySelector('fostr-modal-dialog#MiniCart');
    }
  
    vanillaSerialize (data) {
      let obj = {};
      for (let [key, value] of data) {
        if (obj[key] !== undefined) {
          if (!Array.isArray(obj[key])) {
            obj[key] = [obj[key]];
          }
          obj[key].push(value);
        } else {
          obj[key] = value;
        }
      }
      return obj;
    }
  
    onSubmitHandler(evt) {
      evt.preventDefault();
      
      const submitButton = this.querySelector('[type="submit"]');
      const formData = new FormData(this.form);
      let lineItemMessage = '';
  
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');
  
      let itemsArr = [];
      let prodID = this.form.querySelector('input[name="id"]').value;
      const hasFreeEngraving = this.form.querySelector('input[name="service-customization-free-engraving"]');
      const preorderMessages = document.getElementsByClassName('preorder-message');
      for (let i = 0; i < preorderMessages.length; i++) {
        if(preorderMessages[i].classList.contains('active')){
          lineItemMessage = preorderMessages[i].textContent.trim();
        }
      }
  
      
      const properties = {};

      if(lineItemMessage) {
        properties['Delivery'] = lineItemMessage;
      }

      if(hasFreeEngraving){
        properties['_service-customization-free-engraving'] = 'true';
      }
      // Legacy bundle component
      const bundleComponent = document.querySelector('product-bundle-form');
      const isProductTriovalid = bundleComponent && bundleComponent.variantIds && bundleComponent.variantIds.length > 0 && !bundleComponent.soapNoBundleVariantId && !bundleComponent.mixBundleActive

      const isSoapCase = bundleComponent && bundleComponent.mixBundleActive && bundleComponent.soapNoBundleVariantId
      let isSoapBundleValid = bundleComponent && bundleComponent.variantIds && bundleComponent.variantIds.length > 0 && isSoapCase;

      if(isSoapCase && !isSoapBundleValid) {
        // Case were user skip the mandatory variant selection
        console.error('Soap bundle is not valid');
        return;

      } else if(isProductTriovalid || isSoapBundleValid) {
        let variantsId = '';
        
        if(isSoapBundleValid){
          variantsId = bundleComponent.soapNoBundleVariantId + ',' + bundleComponent.variantIds.join(',');
        } else {
          variantsId = bundleComponent.variantIds.join(',');
        }

        properties['_bundle_component'] = variantsId;
      }

      // tmp case for soap bundle case without any children
      if(bundleComponent && bundleComponent.soapNoBundleVariantId && !bundleComponent.mixBundleActive){
        prodID = bundleComponent.soapNoBundleVariantId;
      }

      // New bundle component
      const bundleStore = Alpine.store('productBundle');
      if(bundleStore && bundleStore.isReady && bundleStore.variantIds && bundleStore.variantIds.length > 0) {
        const variantsId = bundleStore.variantIds.join(',');
        properties['_bundle_component'] = variantsId;
      }

      const item = {
        id: prodID,
        quantity: 1,
        ...(Object.keys(properties).length > 0 && { properties })
      };

      itemsArr.push(item);
  
      const body = JSON.stringify({
        items: itemsArr,
        sections: this.cartItems.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });
  
      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status == 422) {
            const cartError = document.querySelector('.mini-cart-add-error');
            if (cartError) {
              cartError.classList.remove('hidden');
              cartError.innerHTML = parsedState.description || window.cartStrings.error;
            }

            this.miniCart?.show();
          } else {
            document.querySelector('.mini-cart-add-error').classList.add('hidden');
            this.cartItems.renderContents(parsedState);
            return this.cartItems.checkGifts();
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }
}
  
customElements.define('product-form', ProductForm);